import React from "react"
import { compose } from 'ramda'
import {
    logo,
    monitoring_inactive,
    monitoring_active,
    manage_inactive,
    manage_active,
    bell,
    alert,
    logout,
    settings,
    herd,
    back,
    sort_asc,
    sort_desc,
    arrow,
    procreation,
    loupe,
    expand,
    remove,
    add,
    tooltip,
    edit,
    add_note,
    report,
    coming_heat,
    insemination_confirmed,
    insemination_unconfirmed,
    last_delivery,
    planned_delivery,
    calendar,
    icon_tick,
    account,
    objects,
    users,
    notifications,
    icon_untick,
    day,
    night,
    no_sensors,
    grace_period,
    tail_sensors,
    select_all,
    unselect_all,
    alarm,
    groups,
    cow,
    clock,
    confirm,
    zones,
    manual,
    herd_no_fill,
    arrowhead
} from '../../assets/icons'
import { IconStyled } from './styled'

const Icon = props => {
    const getIcon = name => {
        switch (name) {
            case 'logo':
                return logo
            case 'monitoring_inactive':
                return monitoring_inactive
            case 'monitoring_active':
                return monitoring_active
            case 'manage_inactive':
                return manage_inactive
            case 'manage_active':
                return manage_active
            case 'bell':
                return bell
            case 'alert':
                return alert
            case 'logout':
                return logout
            case 'settings':
                return settings
            case 'herd':
                return herd
            case 'back':
                return back
            case 'sort_asc':
                return sort_asc
            case 'sort_desc':
                return sort_desc
            case 'arrow':
                return arrow
            case 'procreation':
                return procreation
            case 'loupe':
                return loupe
            case 'expand':
                return expand
            case 'remove':
                return remove
            case 'add':
                return add
            case 'tooltip':
                return tooltip
            case 'edit':
                return edit
            case 'add_note':
                return add_note
            case 'report':
                return report
            case 'coming_heat':
                return coming_heat
            case 'insemination_confirmed':
                return insemination_confirmed
            case 'insemination_unconfirmed':
                return insemination_unconfirmed
            case 'last_delivery':
                return last_delivery
            case 'planned_delivery':
                return planned_delivery
            case 'calendar':
                return calendar;
            case 'icon_tick':
                return icon_tick;
            case 'icon_untick':
                return icon_untick;
            case 'account':
                return account;
            case 'objects':
                return objects;
            case 'users':
                return users;
            case 'notifications':
                return notifications;
            case 'day':
                return day;
            case 'night':
                return night;
            case 'no_sensors':
                return no_sensors;
            case 'grace_period':
                return grace_period;
            case 'tail_sensors':
                return tail_sensors;
            case 'select_all':
                return select_all;
            case 'unselect_all':
                return unselect_all;
            case 'alarm':
                return alarm;
            case 'groups':
                return groups;
            case 'cow':
                return cow;
            case 'clock':
                return clock;
            case 'confirm':
                return confirm;
            case 'zones':
                return zones;
            case 'manual':
                return manual;
            case 'herd_no_fill':
                return herd_no_fill;
            case 'arrowhead': 
                return arrowhead;
            default:
                return () => { }
        }
    }
    const setProperties = (width, height, color, number) => icon => icon(width, height, color, number)
    return (
        <IconStyled
            {...props}
            dangerouslySetInnerHTML={{
                __html: compose(
                    setProperties(props.width, props.height, props.color, props.number),
                    getIcon
                )(props.name)
            }}
        />
    )
}

export default Icon